enum Routes {
  ADDRESS = "ADDRESS",
  API = "API",
  ASSETS = "ASSETS",
  ASSET = "ASSET",
  BLOCK = "BLOCK",
  BLOCKS = "BLOCKS",
  BURNS = "BURNS",
  DISTRIBUTION = "DISTRIBUTION",
  HOME = "HOME",
  MARKETS = "MARKETS",
  MINING = "MINING",
  MOVEMENTS = "MOVEMENTS",
  NETWORK = "NETWORK",
  RICHLIST = "RICHLIST",
  STATS = "STATS",
  TRANSACTION = "TRANSACTION",
}

export default Routes;
